export default __webpack_public_path__ + "static/media/placeholder-avatar.0702cbf5.png";